import { createFileRoute } from "@tanstack/react-router";
import { SimCardsPage } from "@charphq/ui/components/pages/SimCardsPage";

export const Route = createFileRoute("/sim-cards")({
  component: function SimCardsRoute() {
    const search = Route.useSearch();
    return <SimCardsPage searchParams={search} />;
  },
  validateSearch: (search: Record<string, unknown>) => ({
    page: Number(search.page) || 1,
    pageSize: Number(search.pageSize) || 20,
    sortBy: (search.sortBy as string) || undefined,
    sortDirection: (search.sortDirection as "asc" | "desc") || undefined,
    globalFilter: (search.globalFilter as string) || undefined,
    columnFilters: (search.columnFilters as Record<string, unknown>) || undefined,
  }),
});
